import api from '../api'

export function createSupportCheckout(organizationApikey, amountCents, isRecurring = false) {
  if (!organizationApikey) throw new Error('organizationApikey is required')
  if (!amountCents) throw new Error('amountCents is required')

  const checkoutKey = `organization:${organizationApikey}:support:creatingCheckout`
  const checkoutErrorKey = `${checkoutKey}Error`

  if (this.getState()[checkoutKey]) return

  this.setState({
    [checkoutKey]: true,
    [checkoutErrorKey]: undefined,
  })

  api.createOrganizationSupportCheckout({ organizationApikey, amountCents, isRecurring }).then(
    ({ checkoutUrl }) => {
      this.setState({
        [checkoutKey]: false,
      })
      if (checkoutUrl) {
        window.location.href = checkoutUrl
      }
    },
    error => {
      this.setState({
        [checkoutKey]: false,
        [checkoutErrorKey]: error,
      })
    }
  )
}

export function loadSupporters(organizationApikey, page = 1, limit = 50) {
  if (!organizationApikey) throw new Error('organizationApikey is required')

  const supportersKey = `organization:${organizationApikey}:supporters`
  const loadingKey = `${supportersKey}:loading`
  const errorKey = `${supportersKey}:error`
  const paginationKey = `${supportersKey}:pagination`

  if (this.getState()[loadingKey]) return

  this.setState({
    [loadingKey]: true,
    [errorKey]: undefined,
  })

  api.getOrganizationSupporters({ organizationApikey, page, limit }).then(
    (result) => {
      const totalPages = Math.ceil((result.total || 0) / (result.limit || 50))
      this.setState({
        [loadingKey]: false,
        [supportersKey]: result.supporters || [],
        [paginationKey]: {
          page: page,
          total: result.total || 0,
          totalPages: totalPages,
          limit: result.limit || 50,
          offset: result.offset || 0,
        },
      })
    },
    error => {
      this.setState({
        [loadingKey]: false,
        [errorKey]: error,
      })
    }
  )
}

export function loadMySupportedHubs() {
  const supportedHubsKey = 'mySupportedHubs'
  const loadingKey = `${supportedHubsKey}:loading`
  const errorKey = `${supportedHubsKey}:error`

  if (this.getState()[loadingKey]) return

  this.setState({
    [loadingKey]: true,
    [errorKey]: undefined,
  })

  api.getMySupportedHubs().then(
    (result) => {
      console.log('getMySupportedHubs from org sup action', result)
      this.setState({
        [loadingKey]: false,
        [supportedHubsKey]: result.supportedHubs || [],
      })
    },
    error => {
      this.setState({
        [loadingKey]: false,
        [errorKey]: error,
      })
    }
  )
}

export function cancelHubSupport(supportId) {
  if (!supportId) throw new Error('supportId is required')

  const cancellingKey = `mySupportedHubs:cancelling:${supportId}`
  const errorKey = `${cancellingKey}Error`

  if (this.getState()[cancellingKey]) return

  this.setState({
    [cancellingKey]: true,
    [errorKey]: undefined,
  })

  api.cancelHubSupport({ supportId }).then(
    () => {
      this.setState({
        [cancellingKey]: false,
      })
      // Remove from list
      const supportedHubsKey = 'mySupportedHubs'
      const currentHubs = this.getState()[supportedHubsKey] || []
      this.setState({
        [supportedHubsKey]: currentHubs.filter(h => h.id !== supportId),
      })
    },
    error => {
      this.setState({
        [cancellingKey]: false,
        [errorKey]: error,
      })
    }
  )
}
